<template>
  <div class="search-block">

      <div class="search-input">
        <h4 v-if="!searchResult" >Поиск исполнителя</h4>
        <div class="security-options">
          <input
          @keyup.enter="search" 
          v-model="searchText" 
          class="input border-search" 
          placeholder="ИНН или название компании" />
          <input type="text" v-model="driverName" class="input border-search" @keyup.enter="search" >
          <font-awesome-icon 
          @click="search" 
          class="icon border-search" 
          icon="fa-solid fa-magnifying-glass" />
          
        </div>
      </div>

      <div v-if="searchResult && !notFound" class="search-result small">
        <table class="company-table">
          <thead>
            <tr>
              <th>Компания</th>
              <th>Менеджер</th>
              <th>Водитель</th>
              <th>Автомобиль</th>
              <th>Прицеп</th>
              <th>Статус</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in searchResult" :key="row.id" 
            @click="chooseExecutor(row)"
            :class="{'item':true, 'hover':row.is_success, 'deactiv':!row.is_success,'activ':row.is_success}" >
              <td>
                  <p>{{ row.name }}</p>
              </td>
              <td>
                  <p>{{row.manager_name}}</p>
              </td>
              <td>
                  <p>{{ row.first_name }} {{ row.last_name }} {{ row.surname }}</p>
              </td>
              <td>
                  <p>{{row.car_number}}</p>
              </td>
              <td v-if="row.trailer_number">
                  <p>{{row.trailer_number}}</p>
              </td>
              <td v-else>Нет</td>
              <td>
                <p v-if="row.is_success">Готов</p>
                <p v-else>Не подтвержден</p>
              </td>
            </tr>
          </tbody>

        </table>
      </div>
      <div v-if="isConfirm" class="confirm-block">
        <h5>Выбрать этого исполнителя?</h5>
        <div class="">
          <div class="confirn-info">
            <p>{{ selectExecutor.name }}</p>
            <p>{{ selectExecutor.manager_name }}</p>
            <p>{{ selectExecutor.first_name }}</p>
            <p>{{ selectExecutor.car_number }}</p>
            <p v-if="selectExecutor.trailer_number">{{ selectExecutor.trailer_number }}</p>
            <p v-else>Нет</p>
          </div>
          <div class="confirm-btn">
            <p class="p-success hover" @click="confirmChoose">Да</p>
            <p class="p-denied hover" @click="reserChoose">Нет</p>
          </div>
        </div>
      </div>
      <div class="search-result" v-if="notFound">
        <p>Не найден</p>
      </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import { useStore } from 'vuex'
import ApiConnector from '@/backend/apiModels/userApi'

export default {
  name:'ExecutorFormSearch',
  setup(_,{emit}) {    

    const api = new ApiConnector()
    const searchText = ref('')
    const driverName =ref('')
    const searchResult = ref(null)
    const notFound = ref(false)
    const isConfirm = ref(false)
    const selectExecutor = ref(null)

    const chooseExecutor = exct =>{
      if(exct.is_success){
        selectExecutor.value = exct
        isConfirm.value = true
      }
    }

    const reserChoose = ()=>{
      selectExecutor.value = null
      isConfirm.value = false
    }

    const confirmChoose = () =>{
      if (selectExecutor.value){
        emit('setExecutor',selectExecutor.value.id)
        selectExecutor.value = null
        isConfirm.value = false
      }
    }

    const getSearchForm = ()=>{
      const form = {company:{},driver:{}};
      if (/^\d+$/.test(searchText.value)) {
        form.company.inn = searchText.value;
      } else {
        form.company.name = searchText.value;
      }
      if (driverName.value){
        form.driver.first_name = driverName.value
      }
      return form
    }

    const search = async () =>{
      if(!searchText.value) return
      const form = getSearchForm()
      const link = 'executors/search'
      const {response,request} = api.post(link,form)
      
      await request()
      notFound.value = response.value.length === 0;
      searchResult.value = notFound.value ? null : response.value.executors;
    }

    return {
      driverName,
      confirmChoose,
      reserChoose,
      selectExecutor,
      isConfirm,
      chooseExecutor,
      searchText,
      search,
      searchResult,
      notFound
    };
  },
};
</script>

<style scoped>
.search-block{
  text-align: center;
}

.deactiv{
  background-color: rgba(251,127,139, 0.6);
}

.activ{
  background-color: rgba(152,236,131, 0.6);
}

.security-options{
  margin-top: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.search-result{
  padding: 5px;
  display: flex;
  justify-content: center;
  margin-top: 20px;
  max-height: 350px;
  overflow-y:auto
}

.input{
  min-width: 250px;
  margin-left: 10px;
}

.icon{
  margin-left: 10px;
}


.small{
  font-size: 12px;
}

.company-table {
  padding: 5px;
  border-collapse: collapse;
  
}

.company-table td:first{
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}

.company-table td {
  text-align: center;
  padding: 3px;
  /* border: 1px solid #ccc; */
}

.company-table th {
  font-weight: bold;
}

.hover:hover{
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.1);
}

.border-search{
  border: 2px solid #ccc;
  padding: 2px;
  border-radius: 3px;
}

.confirm-block{
  margin-top: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.confirn-info{
  display: flex;
}

.confirn-info p{
  border: 1px solid #ccc;
  padding: 4px;
  margin-left: 2px;
  margin-right: 2px;
  font-size: 12px;
  border-radius: 3px;
}

.confirm-btn{
  margin-top: 15px;
  display: flex;
  justify-content: center;
}

.confirm-block h5{
  margin-bottom: 10px;
}

.confirm-btn p{
  border-radius: 5px;
  margin-left: 10px;
  width: 50px;
  padding: 3px;
  border: 1px solid #ccc;
}

.p-success{
  background-color: rgba(152,236,131, 1.0);
}

.p-denied{
 background-color: rgba(251,127,139, 1.0); 
}
</style>
